import './AmcGeoDataCards.scss';
import { abbreviateNumber } from '@src/utils/data';
import { DataCard } from '@Components/DataCard';

interface GeoCardData {
  state?: string;
  impressions?: number;
  reach?: number;
  dpv?: number;
  customersConverted?: number;
  orders?: number;
  revenue?: number;
  ntbCustomers?: number;
  dpvRate?: number;
  conversionRate?: number;
  ntbRepeatRate?: number;
  ntbPurchaseRate?: number;
}

interface AmcGeoDataCardsProps {
  geoCardData: GeoCardData;
  title: string;
}

// Rate fields render with a % suffix; everything else is abbreviated (1234 -> 1.2k).
const RATE_KEYS: (keyof GeoCardData)[] = ['dpvRate', 'conversionRate', 'ntbRepeatRate'];

// Cards the caller renders separately (state selector) or that bpm-frontend never surfaced here.
const EXCLUDED_KEYS: (keyof GeoCardData)[] = ['state', 'ntbPurchaseRate'];

const formatCardLabel = (key: string): string =>
  key
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/ntb/i, 'NTB')
    .replace(/dpv/i, 'DPV');

export const AmcGeoDataCards = ({ geoCardData, title }: AmcGeoDataCardsProps) => {
  const cardKeys = (Object.keys(geoCardData) as (keyof GeoCardData)[]).filter(
    key => !EXCLUDED_KEYS.includes(key)
  );

  return (
    <div className='amc-geo-data-cards'>
      <div className='amc-geo-data-cards-title'>{title}</div>
      <div className='amc-geo-data-cards-grid'>
        {cardKeys.map(key => (
          <DataCard
            key={key}
            label={formatCardLabel(key)}
            value={
              RATE_KEYS.includes(key)
                ? `${geoCardData[key]}%`
                : abbreviateNumber(Number(geoCardData[key]))
            }
            width='105px'
          />
        ))}
      </div>
    </div>
  );
};
